

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxAutocomplete, DxRadioGroup } from 'devextreme-vue';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import MailDialog from '@/modules/progressStatements/components/MailPopup.vue';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';

import { DxForm, DxSimpleItem, DxLabel } from 'devextreme-vue/form';

import {
  ProgressStatement,
  ProgressStatementsClient,
  FinanceDocumentSettings,
  GenerateProgressStatementDocumentCommand,
  ExportProgressStatementCommand,
  ProgressStatementExportType,
  ExportPdfProgressStatementCommand,
} from '@/data/web-api-client';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxAutocomplete,
    DxRadioGroup,
    MailDialog,
    PdfViewer,
  },
})
export default class ProgressStatementDocument extends Vue {
  @Prop({ required: true })
  progressStatement!: ProgressStatement;

  pdfSize: number = 450;
  settings: FinanceDocumentSettings = new FinanceDocumentSettings({
    hideUnitPrices: false,
    hideLineTotals: false,
    hideLineAmounts: false,
    hideSubtotals: false,
    hideTotals: false,
    groupArticlesByCategory: false,
  });
  selectedExportType = ProgressStatementExportType.Standard;
  progressStatementExportTypeEnum = ProgressStatementExportType;
  document: {
    loading: boolean;
    initialised: boolean;
    url: string;
  } = {
    loading: false,
    initialised: false,
    url: '',
  };
  languages: any[] = [];

  private progressStatementsClient = new ProgressStatementsClient(undefined, this.$axios);

  created() {
    this.pdfSize = window.innerHeight - 275;
    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];

    if (this.progressStatement.documentSettings && this.progressStatement.documentSettings !== null) {
      Object.assign(this.settings, this.progressStatement.documentSettings);
    }

    this.loadDocument();
  }

  async downloadExport($event: any) {
    $event.preventDefault();
    $event.stopPropagation();

    try {
      const fileResponse = await this.progressStatementsClient.export(
        new ExportProgressStatementCommand({
          projectId: this.progressStatement.projectId,
          currentProgressStatement: this.mergedDocumentNumber,
          language: this.settings.language,
        })
      );
      const blob = fileResponse.data;
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');

      anchor.download = fileResponse.fileName ?? 'download';
      anchor.href = url;
      anchor.click();
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async downloadExportPdf($event: any) {
    $event.preventDefault();
    $event.stopPropagation();

    try {
      const fileResponse = await this.progressStatementsClient.exportPdf(
        new ExportPdfProgressStatementCommand({
          projectId: this.progressStatement.projectId,
          currentProgressStatement: this.mergedDocumentNumber,
          language: this.settings.language,
        })
      );
      const blob = fileResponse.data;
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');

      anchor.download = fileResponse.fileName ?? 'download';
      anchor.href = url;
      anchor.click();
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async loadDocument() {
    try {
      this.document.loading = true;
      const result = await new ProgressStatementsClient(undefined, this.$axios).getDocument(this.mergedDocumentNumber!.replaceAll('/', '-'));

      this.document.url = window.URL.createObjectURL(result.data);
      this.document.initialised = true;
    } catch (err) {
      this.generateDocument();
    } finally {
      this.document.loading = false;
    }
  }

  async generateDocument() {
    try {
      this.document.loading = true;
      const result = await new ProgressStatementsClient(undefined, this.$axios).generateDocument(
        this.mergedDocumentNumber!.replaceAll('/', '-'),
        new GenerateProgressStatementDocumentCommand({
          documentNumber: this.mergedDocumentNumber,
          documentSettings: new FinanceDocumentSettings(this.settings),
          versionNumber: this.progressStatement.versionNumber,
        })
      );

      this.document.url = window.URL.createObjectURL(result.data);
      this.document.initialised = true;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  openMailDialog() {
    this.mailDialog.open();
  }

  mailSend() {
    this.$emit('mailSend');
  }

  get mergedDocumentNumber() {
    return `${this.progressStatement.documentNumber}-${this.progressStatement.versionNumber}`;
  }

  get exportOptions() {
    return [
      {
        id: ProgressStatementExportType.Standard,
        value: 'Standaard vorderstaat',
      },
      {
        id: ProgressStatementExportType.Excel,
        value: 'Uitgebreide vorderstaat (Excel)',
      },
      {
        id: ProgressStatementExportType.Pdf,
        value: 'Uitgebreide vorderstaat (Pdf)',
      },
    ];
  }

  get mailDialog() {
    return this.$refs.MailDialog as MailDialog;
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      showClearButton: 'true',
    };
  }
}
